import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../../../../styles/const/colors'

const useStyles = createUseStyles({
  userMenuContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 16
  },
  userImage: {
    width: 40
  },
  arrowIcon: {
    fill: mediumGrey
  },
  userDropdown: {
    padding: '22px 12px 12px',
    textAlign: 'center',
    cursor: 'auto'
  },
  userEmail: {
    marginTop: 2,
    fontSize: 12,
    color: mediumGrey
  },
  userNavWrapper: {
    marginTop: 18
  }
})

export default useStyles
